var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clazz_show_header bgwhite"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"clazz_name"},[_vm._v(_vm._s(_vm.clazz.clazz_name))]),_c('div',{staticClass:"time_range"},[_vm._v("\n      "+_vm._s(_vm.clazz.start_time_format2)+" ~\n      "+_vm._s(_vm.clazz.end_time_format2)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }